/* eslint-disable camelcase */
import { maska } from 'maska';

const ERRORS = {
    emptyField: 'Поле обязательно для заполнения',
    invalidEmail: 'Введите корректный E-mail',
    invalidPhone: 'Неверный формат телефона',
    invalidFile: 'Неверный формат файла',
    invalidAgreement: 'Подтвердите согласие',
};

const REQUEST_TYPES = [
    {
        value: 'documentation-clarification',
        title: 'на разъяснение документации',
    },
    {
        value: 'object-inspection',
        title: 'на осмотр объекта',
    },
];

const EMPTY_STATE = {
    detail_form: REQUEST_TYPES[0].title,
    form_text_1: null,
    form_text_2: null,
    form_text_3: null,
    form_text_4: null,
    form_file_5: [],
    agreement: null,
    agreementAdvId: null,
};

export default {
    directives: { maska },
    props: {
        action: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            form: {
                form_text_1: null,
                form_text_2: null,
                form_text_3: null,
                form_text_4: null,
                agreement: null,
                agreementAdvId: null,
            },
            isSubmitting: false,
            isSuccessSend: false,
        };
    },
    computed: {
        submitBtnActive() {
            // По умолчанию, кнопка должна быть активна
            // при нажатии на нее, должна показываться валидация,
            // но при этом, кнопка всегда неактивна, если форма уже отправлена
            // за это отвечает поле isSubmitting
            return !this.isSubmitting;
        },
        canSendForm() {
            // Только если поля валидны и не была нажата кнопка отправки
            return (
                this.fieldsValid.form_text_1.valid &&
                this.fieldsValid.form_text_2.valid &&
                this.fieldsValid.form_text_3.valid &&
                this.fieldsValid.form_text_4.valid &&
                this.fieldsValid.agreement.valid &&
                !this.isSubmitting
            );
        },
        fieldsValid() {
            const {
                form_text_1,
                agreement,
                form_text_2,
                form_text_3,
                form_text_4,
            } = this.form;

            return {
                form_text_1: this.validateLength(form_text_1),
                form_text_2: this.validatePhone(form_text_2),
                form_text_3: this.validateEmail(form_text_3),
                form_text_4: this.validateLength(form_text_4),
                agreement: this.validateAgreement(agreement),
            };
        },
    },
    methods: {
        getFormValues() {
            const { form } = this.$refs;
            if (!form) {
                return;
            }

            const formData = new FormData(form);
            if (!formData) {
                return;
            }

            const formValues = {};
            for (const key of formData.keys()) {
                console.log(200, key, formData.get(key));
                formValues[key] = formData.get(key);
            }
            return formValues;
        },
        fillEmptyFields() {
            const keys = Object.keys(this.form);
            keys.forEach((key) => {
                if (this.form[key] === null) {
                    this.form[key] = '';
                }
            });
        },
        /**
         * Проверка на валидность всей формы
         * @returns {this is ({valid, error: (*|null)} | {valid, error: (*|null)})[]}
         */
        checkAllValidity() {
            const fieldsValid = Object.values(this.fieldsValid);
            return fieldsValid.every((field) => field.valid);
        },
        /**
         * Возвращает валидность поля и ошибку если указана
         * @param value
         * @param error
         * @returns {{valid, error: (*|null)}}
         */
        returnError(value, error = null) {
            return {
                valid: value,
                error: error ? ERRORS[error] : null,
            };
        },
        /**
         * Проверка валидности емаила
         * @param email
         * @returns {{valid, error: (*|null)}}
         */
        validateEmail(email) {
            if (!email || email?.length < 3) {
                return this.returnError(false, 'emptyField');
            }
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const emailTest = re.test(String(email).toLowerCase());
            return emailTest
                ? this.returnError(true)
                : this.returnError(false, 'invalidEmail');
        },
        /**
         * Проверка валидности длины поля
         * @param value
         * @returns {{valid, error: (*|null)}}
         */
        validateLength(value) {
            if (value && value.length > 1) {
                return this.returnError(true);
            }
            return this.returnError(false, 'emptyField');
        },
        /**
         * Проверка валидности телефона
         * @param phone
         * @returns {{valid, error: (*|null)}}
         */
        validatePhone(phone) {
            if (!phone) {
                return this.returnError(false, 'emptyField');
            }
            if (
                phone &&
                phone.length < (this.validLength ? this.validLength : 10)
            ) {
                return this.returnError(false, 'emptyField');
            }
            const clearSymbol = phone
                ?.replaceAll('(', '')
                ?.replaceAll(')', '')
                ?.replaceAll('-', '');
            const phoneTest =
                /^\+?\d{0,3}?[- .]?\(?(?:\d{3})\)?[- .]?\d{3}[- .]?\d{4}$/.test(
                    clearSymbol
                );

            return phoneTest
                ? this.returnError(true)
                : this.returnError(false, 'invalidPhone');
        },
        validateAgreement(agreement) {
            if (agreement === '1') {
                return this.returnError(true);
            }
            return this.returnError(false, 'invalidAgreement');
        },
        clearForm() {
            this.form = { ...this.form, ...EMPTY_STATE };
            this.isSubmitting = false;
        },
    },
};
